// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"408":"5eb862a7","748":"54b3437f","828":"7cbc575b"}[chunkId] + ".chunk.js";
};